import { useEffect } from "react";
import "./ServiceBanner.css";
import ServiceDetailsData from "./ServiceDetailsData";
import { FloatingWhatsApp } from "react-floating-whatsapp";
import {whatsAppBotListener } from "../../utils/Utils";
import { PHONE_NUMBER } from "../../utils/Constant";
import clinicIcon from '../../assets/ivory/DenviaLogo.png';

const ServiceBanner = () => {
  useEffect(() => {
  window.scrollTo(0, 0);

  // check if URL has #slug
  const hash = window.location.hash.replace("#", "");
  if (hash) {
    setTimeout(() => {
      const section = document.getElementById(hash);
      if (section) {
        section.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 300);
  }
}, []);


  // Function to bold the service title inside its description
  const highlightTitle = (description, title) => {
    const regex = new RegExp(title, "i"); // case-insensitive match
    return description.replace(regex, `<strong>${title}</strong>`);
  };

  return (
    <section className="service-banner-section">
      <div className="service-banner-content container">
        <h1 className="service-banner-title">Our Dental Services</h1>
        <p className="service-intro">
          We provide a complete range of advanced dental care solutions to keep your smile bright, healthy, and confident.
        </p>

        {ServiceDetailsData.map((service, index) => (
          <div
            key={service.id}
            id={service.slug}
            className={`service-full-block ${index % 2 === 0 ? "normal" : "reverse"}`}
            // data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
            // data-aos-duration="1500"
          >
            <div className="serviceImageDiv">
              <img src={service.image} className="servicesImage" alt={service.title} />
            </div>

            <div className="service-text-content">
              <h2 className="service-title">{service.title}</h2>
              <p
                className="service-intro-text"
                dangerouslySetInnerHTML={{
                  __html: highlightTitle(service.description, service.title),
                }}
              ></p>
            </div>
          </div>
        ))}
      </div>
{/* What's app bot section */}
                  <FloatingWhatsApp
                      avatar={clinicIcon}
                      notification={false}
                      accountName="Denvia Dental Clinic"
                      phoneNumber={PHONE_NUMBER}
                      onSubmit={(e) => {
                          whatsAppBotListener(e.target[0].value);
                      }}
            />
    </section>
  );
};

export default ServiceBanner;
